// src/pages/Projeto/ProjetoPage.jsx
import React from 'react';
import ProjetoList from '../../components/Projeto/ProjetoList';
import { Link } from 'react-router-dom';

const ProjetoPage = () => {
    return (
        <div>
            <h1>Gestão de Projetos</h1>
            <Link to="/projetos/submeter">Submeter Novo Projeto</Link>
            <ProjetoList />
        </div>
    );
};

export default ProjetoPage;